import {
  GET_BUSINESSRULES_FLEXIBILITY,
  GET_CREATE_FLEXIBILITY_DATA,
  SET_HOLIDAYS_OR_SEASONS,
  FILE_UPLOAD_PAGE
} from "../constants/action-types";

//Business Rules Actions
export function getBusinessRulesFlexibility(data) {
  let payload = data;
  return { type: GET_BUSINESSRULES_FLEXIBILITY, payload };
}

export function getUnknownRulesData(data) {
  let payload = data;
  return { type: GET_CREATE_FLEXIBILITY_DATA, payload };
}

//Calender Tab
export function setHolidaysOrSeasons(data){
  let payload = data;
  return {type: SET_HOLIDAYS_OR_SEASONS, payload}
}

//FileUpload
export function fileUploadPage(data){
  let payload = data;
  return {type: FILE_UPLOAD_PAGE, payload}
}
